// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"styles_dataTable__3FoH6","taskItem":"styles_taskItem__U1ZK6","footerRow":"styles_footerRow__27bGA"};